<div class="side-nav-container">
    <div class="menu-header">
        <mat-icon *casOnceNgIf="!isDesktop()" class="close-menu-icon" (click)="closeMenu()">clear</mat-icon>
        <mat-icon class="logo" svgIcon="caslink-white"></mat-icon>
    </div>
    <div class="user">
        <button
            class="user-button borderless"
            [matMenuTriggerFor]="userMenu">
            <span class="user-title">
                <mat-icon class="profile">account_circle</mat-icon>
                <span class="user-name spacer"
                      *casOneTime
                      [innerText]="getName()"
                      [ngClass]="{'smaller-text': isUsernameLong()}">
                </span>
            </span>
        </button>
        <mat-menu #userMenu="matMenu">
            <ng-template matMenuContent>
                <button
                    *ngFor="let userNavigation of userNavigations"
                    (click)="navigate(userNavigation)"
                    mat-menu-item>
                    <mat-icon>{{userNavigation.icon}}</mat-icon>
                    <span
                        class="menu-title"
                        *casOneTime
                        [innerText]="userNavigation.name"></span>
                </button>
            </ng-template>
        </mat-menu>
    </div>
    <div id="main-menu" class="layout-column spacer">
        <ng-container *ngFor="let navigation of navigationService.navigations; trackBy: trackByName ">
            <button
                *ngIf="navigation.isVisible()"
                (click)="navigate(navigation)"
                mat-flat-button>
            <mat-icon>{{navigation.icon}}</mat-icon>
            <span
                class="menu-title"
                *casOneTime
                [innerText]="navigation.name">
            </span>
        </button>
        </ng-container>
        <div class="spacer"></div>
    </div>
</div>
